import React from "react";
import { string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./textfield.m.css";

const TextField = ({ value, type, error, label, inputType, publisherAttributes, ...props }) => (
  <div styleName={`wrapper ${publisherAttributes.lang}-wrapper`} className="wrapper-textfield">
    {label && (
      <label styleName="label" className="label">
        {label}
      </label>
    )}
    <input
      type={type}
      value={value}
      styleName={error ? `${inputType}-error ${inputType}` : inputType}
      className="textfield"
      {...props}
    />
    {error && <span styleName="error">{error}</span>}
  </div>
);

TextField.defaultProps = {
  type: "text",
  inputType: "type1",
};

TextField.propTypes = {
  type: string,
  inputType: string,
  value: string,
  error: string,
  label: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(TextField);
